/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Step_2Inputs */

const en_svc_research_step_2 = /** @type {(inputs: Svc_Research_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build the search, reading and checking steps, with a budget per run.`)
};

const lv_svc_research_step_2 = /** @type {(inputs: Svc_Research_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izveidojam meklēšanas, lasīšanas un pārbaudes soļus ar budžetu katrai palaišanai.`)
};

/**
* | output |
* | --- |
* | "Build the search, reading and checking steps, with a budget per run." |
*
* @param {Svc_Research_Step_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_step_2 = /** @type {((inputs?: Svc_Research_Step_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Step_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_step_2(inputs)
	return en_svc_research_step_2(inputs)
});